// Combined Loop bundle functionality: button reordering, class addition, DOM moving, and custom header injection
// Keep track of whether tasks are complete
let buttonsReordered = false;
let classAdded = false;
let frequencyMoved = false;
let customHeaderInjected = false;
let selectArrowsAdded = false;

console.log('Loop bundles script loaded 2');

// Function to add custom arrows to select elements
function addCustomSelectArrows() {
  if (selectArrowsAdded) return true;
  
  const selectElements = document.querySelectorAll('select.loop-select-variant');
  if (selectElements.length > 0) {
    selectElements.forEach((select, index) => {
      // Check if arrow container already exists
      if (select.parentNode.classList.contains('select-wrapper-with-arrow')) {
        return; // Skip if already processed
      }
      
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'select-wrapper-with-arrow';
      wrapper.style.cssText = `
        position: relative !important;
        display: inline-block !important;
        width: 100% !important;
      `;
      
      // Create arrow element
      const arrow = document.createElement('div');
      arrow.className = 'select-arrow-icon';
      arrow.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon" style="display: block;">
          <path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="2.5" fill="none"/>
        </svg>
      `;
      arrow.style.cssText = `
        position: absolute !important;
        right: 12px !important;
        top: 40% !important;
        transform: translateY(-50%) !important;
        pointer-events: none !important;
        color: #666666 !important;
        z-index: 2 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 14px !important;
        height: 14px !important;
        line-height: 1 !important;
      `;
      
      // Wrap the select element
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);
      wrapper.appendChild(arrow);
      
      // Add hover and focus event listeners to change arrow color
      select.addEventListener('mouseenter', () => {
        arrow.style.color = '#08C5BC !important';
      });
      
      select.addEventListener('mouseleave', () => {
        arrow.style.color = '#666666 !important';
      });
      
      select.addEventListener('focus', () => {
        arrow.style.color = '#08C5BC !important';
      });
      
      select.addEventListener('blur', () => {
        arrow.style.color = '#666666 !important';
      });
    });
    
    selectArrowsAdded = true;
    console.log('✅ Custom select arrows added successfully');
    return true;
  } else {
    console.log('❌ No select.loop-select-variant elements found yet');
    return false;
  }
}

// Targeted function specifically for #loop-background
function addClassToLoopBackground() {
  const loopBackground = document.getElementById('loop-background');
  if (loopBackground) {
    if (!loopBackground.classList.contains('loop-bundles-bcm')) {
      loopBackground.classList.add('loop-bundles-bcm');
      console.log('✅ Successfully added loop-bundles-bcm class to #loop-background');
      console.log('Element classes are now:', loopBackground.className);
      classAdded = true;
      return true;
    } else {
      console.log('✅ loop-bundles-bcm class already exists on #loop-background');
      classAdded = true;
      return true;
    }
  } else {
    console.log('❌ #loop-background element not found yet');
    return false;
  }
}

// Enhanced debug: List all elements with "loop" in their id or class and their details
function debugLoopElements() {
  console.log('=== DEBUGGING LOOP ELEMENTS ===');
  const allElements = document.querySelectorAll('*');
  const loopElements = [];
  
  allElements.forEach(el => {
    const id = el.id || '';
    const className = String(el.className || '');
    if (id.toLowerCase().includes('loop') || className.toLowerCase().includes('loop')) {
      loopElements.push({
        element: el,
        id: id,
        className: className,
        tagName: el.tagName,
        hasLoopBundlesClass: el.classList.contains('loop-bundles-bcm')
      });
    }
  });
  
  console.log('Found', loopElements.length, 'elements with "loop" in id or class:');
  loopElements.forEach((item, index) => {
    console.log(`${index + 1}. <${item.tagName}> id="${item.id}" class="${item.className}" hasLoopBundlesClass:${item.hasLoopBundlesClass}`);
  });
  
  // Also check for any elements that already have loop-bundles-bcm
  const elementsWithBcmClass = document.querySelectorAll('.loop-bundles-bcm');
  console.log('Elements with loop-bundles-bcm class:', elementsWithBcmClass.length);
  elementsWithBcmClass.forEach((el, index) => {
    console.log(`BCM ${index + 1}. <${el.tagName}> id="${el.id}" class="${el.className}"`);
  });
  
  // Specifically check for #loop-background
  const loopBg = document.getElementById('loop-background');
  if (loopBg) {
    console.log('🎯 #loop-background found - classes:', loopBg.className);
  } else {
    console.log('🎯 #loop-background NOT found');
  }
  
  console.log('=== END DEBUG ===');
  
  return loopElements;
}

// Enhanced class injection function
function injectLoopBundlesClass() {
  if (classAdded) return true;
  
  console.log('Attempting to inject loop-bundles-bcm class...');
  
  // First try the specific #loop-background element
  if (addClassToLoopBackground()) {
    return true;
  }
  
  // Fallback to other selectors if #loop-background not found
  const possibleSelectors = [
    '.loop-container',
    '.loop-bs-container',
    '.loop-widget',
    '.loop-app',
    '[id*="loop"]',
    '[class*="loop"]',
    '[data-loop]',
    '[id^="loop"]',
    '[class^="loop"]',
    'div[class*="Loop"]',
    'div[id*="Loop"]'
  ];
  
  let loopElement = null;
  let usedSelector = '';
  
  for (const selector of possibleSelectors) {
    try {
      const elements = document.querySelectorAll(selector);
      if (elements.length > 0) {
        // Prefer elements that look like main containers
        loopElement = Array.from(elements).find(el => {
          const id = el.id || '';
          const className = String(el.className || '');
          return id.includes('background') || 
                 id.includes('container') || 
                 className.includes('container') ||
                 className.includes('background') ||
                 el.children.length > 0; // has child elements
        }) || elements[0]; // fallback to first element
        
        if (loopElement) {
          usedSelector = selector;
          console.log(`Found Loop element with selector: ${selector}`, loopElement);
          break;
        }
      }
    } catch (e) {
      console.warn(`Selector "${selector}" failed:`, e);
    }
  }
  
  if (loopElement && !loopElement.classList.contains('loop-bundles-bcm')) {
    loopElement.classList.add('loop-bundles-bcm');
    classAdded = true;
    console.log('✅ Successfully added loop-bundles-bcm class to:', loopElement);
    console.log('Used selector:', usedSelector);
    console.log('Element details:', {
      id: loopElement.id,
      className: loopElement.className,
      tagName: loopElement.tagName
    });
    return true;
  } else if (loopElement && loopElement.classList.contains('loop-bundles-bcm')) {
    classAdded = true;
    console.log('✅ loop-bundles-bcm class already exists on element');
    return true;
  } else {
    console.warn('❌ No suitable Loop container element found');
    // Log what we did find for debugging
    debugLoopElements();
    return false;
  }
}

function injectCustomHeader() {
  // Try multiple possible container elements
  const possibleContainers = [
    document.getElementById('loop-background'),
    document.querySelector('.loop-bundles-bcm'),
    document.querySelector('[id*="loop"]'),
    document.querySelector('.loop-container'),
    document.querySelector('body')
  ].filter(Boolean);
  
  if (possibleContainers.length > 0) {
    const container = possibleContainers[0];
    
    // Check if custom header doesn't already exist
    const existingHeader = document.querySelector('.bcm-custom-header');
    if (!existingHeader) {
      // Create the custom header HTML
      const customHeader = document.createElement('div');
      customHeader.className = 'bcm-custom-header';
      
      customHeader.innerHTML = `
        <div class="bcm-custom-header-content">
          <h1 class="bcm-custom-header-title">Bundle & Save</h1>
          <p class="bcm-custom-header-subtitle">Get up to 30% when you buy 4 items</p>
          <p class="bcm-custom-header-sub-subtitle">(+ save more when you subscribe)</p>
        </div>
      `;
      
      // Insert at the beginning of the container
      container.insertAdjacentElement('afterbegin', customHeader);
      customHeaderInjected = true;
      console.log('Custom header injected successfully');
      
      return true;
    } else {
      customHeaderInjected = true;
      return true;
    }
  } else {
    return false;
  }
}

// Immediate execution with enhanced debugging
setTimeout(() => {
  console.log('Initial execution after 100ms...');
  debugLoopElements(); // Debug what's available
  addClassToLoopBackground(); // Direct attempt
  injectLoopBundlesClass();
  injectCustomHeader();
  addCustomSelectArrows(); // Add select arrows
}, 100);

const observer = new MutationObserver(() => {
  // Handle custom header injection if not already done
  if (!customHeaderInjected) {
    injectCustomHeader();
  }

  // Handle class injection if not already done - try direct method first
  if (!classAdded) {
    if (!addClassToLoopBackground()) {
      injectLoopBundlesClass();
    }
  }

  // Handle select arrows if not already done
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }

  // Handle button reordering if not already done
  if (!buttonsReordered) {
    const container = document.querySelector('.loop-frequency-selector');
    if (container) {
      const buttons = Array.from(container.querySelectorAll('button'));
      
      const everyMonthBtn = buttons.find(btn => btn.textContent.trim() === "Every Month");
      const every2WeeksBtn = buttons.find(btn => btn.textContent.trim() === "Every 2 Weeks");
      const oneTimeBtn = buttons.find(btn => btn.textContent.trim() === "One Time Delivery");

      if (everyMonthBtn && every2WeeksBtn && oneTimeBtn) {
        // Clear and reorder
        container.innerHTML = '';
        container.appendChild(everyMonthBtn);
        container.appendChild(every2WeeksBtn);
        container.appendChild(oneTimeBtn);
        
        buttonsReordered = true;
      }
    }
  }
  
  // Handle frequency selector moving if not already done
  if (!frequencyMoved) {
    const frequencySelector = document.querySelector('.loop-frequency-size-selector');
    const footerDescriptionWrapper = document.querySelector('.footer-description-wrapper');
    
    if (frequencySelector && footerDescriptionWrapper) {
      // Move the frequency selector before the footer-description-wrapper
      const parentDiv = footerDescriptionWrapper.parentNode;
      parentDiv.insertBefore(frequencySelector, footerDescriptionWrapper);
      frequencyMoved = true;
    }
  }
  
  // Disconnect observer if all tasks are complete
  if (buttonsReordered && classAdded && frequencyMoved && customHeaderInjected && selectArrowsAdded) {
    observer.disconnect();
  }
});

// Start observing the body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['id', 'class']
});

// Also check once when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM Content Loaded - debugging elements...');
  debugLoopElements(); // Debug what's available at DOM load
  
  // Check for custom header injection on DOM load
  if (!customHeaderInjected) {
    injectCustomHeader();
  }
  
  // Try class injection on DOM load - direct method first
  if (!classAdded) {
    if (!addClassToLoopBackground()) {
      injectLoopBundlesClass();
    }
  }

  // Try select arrows on DOM load
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }
  
  // Check for frequency selector moving on DOM load
  const frequencySelector = document.querySelector('.loop-frequency-size-selector');
  const footerDescriptionWrapper = document.querySelector('.footer-description-wrapper');
  
  if (frequencySelector && footerDescriptionWrapper && !frequencyMoved) {
    const parentDiv = footerDescriptionWrapper.parentNode;
    parentDiv.insertBefore(frequencySelector, footerDescriptionWrapper);
    frequencyMoved = true;
  }
  
  // If all tasks are complete, disconnect the observer
  if (buttonsReordered && classAdded && frequencyMoved && customHeaderInjected && selectArrowsAdded) {
    observer.disconnect();
  }
});

// More aggressive backup checks with direct targeting
setTimeout(() => {
  console.log('Backup check #1 after 1 second...');
  if (!classAdded) {
    addClassToLoopBackground() || injectLoopBundlesClass();
  }
  if (!customHeaderInjected) {
    injectCustomHeader();
  }
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }
}, 1000);

setTimeout(() => {
  console.log('Backup check #2 after 3 seconds...');
  debugLoopElements(); // Debug check
  if (!classAdded) {
    addClassToLoopBackground() || injectLoopBundlesClass();
  }
  if (!customHeaderInjected) {
    injectCustomHeader();
  }
  if (!selectArrowsAdded) {
    addCustomSelectArrows();
  }
}, 3000);

setTimeout(() => {
  console.log('Final check after 5 seconds...');
  debugLoopElements(); // Final debug check
  
  if (!classAdded) {
    console.warn('⚠️ FINAL WARNING: loop-bundles-bcm class was never successfully added');
    addClassToLoopBackground() || injectLoopBundlesClass();
  } else {
    console.log('✅ Class injection completed successfully');
  }
  
  if (!customHeaderInjected) {
    console.warn('⚠️ FINAL WARNING: Custom header was never successfully injected');
    injectCustomHeader();
  } else {
    console.log('✅ Custom header injection completed successfully');
  }

  if (!selectArrowsAdded) {
    console.warn('⚠️ FINAL WARNING: Select arrows were never successfully added');
    addCustomSelectArrows();
  } else {
    console.log('✅ Select arrows added successfully');
  }
}, 5000); 